import React, { useEffect, useState } from "react";
import { Button, Input, Form } from "antd";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

import { useTelegram } from "../../hooks/useTelegram";

import "./CurrenciesPageStyles.css";

import { YuIcon, RuIcon, DolIcon, ExcnahgeIcom } from "./icons/CurrenciesIcon";
import { CONFIG } from "../../constants/config";

const CurrenciesPage = () => {
  const [currrencyRu, setCurrencyRu] = useState({});
  const [currrencyDRu, setCurrencyDRu] = useState({});
  const [currrencyTj, setCurrencyTj] = useState({});
  const [currrencyDT, setCurrencyDT] = useState({});

  const [currrencyYuan, setCurrencyYuan] = useState({
    key: "first",
    title: "Юань",
    value: "1",
  });
  const [currrencyDolar, setCurrencyDolar] = useState({
    key: "third",
    title: "Доллар",
    value: "1",
  });
  const [currrencyTYuan, setCurrencyTYuan] = useState({
    key: "fifth",
    title: "Рубль",
    value: "1000",
  });

  const [currrencyDTj, setCurrencyDTj] = useState({
    key: "seven",
    title: "Доллар",
    value: "1",
  });

  const [loading, setLoading] = useState(false);
  const [loadData, setLoadData] = useState("");
  const [searchParams] = useSearchParams();

  const { tg, onClose } = useTelegram();
  tg.MainButton.hide();
  const apiKey = searchParams.get("api_key");

  const onSendDataToBot = (data) => {
    tg.sendData(JSON.stringify(data));
  };

  useEffect(() => {
    axios
      .get(`${CONFIG.API_URL}/currency?api_key=${apiKey}`)
      .then(({ data }) => {
        const parsedData = JSON.parse(data[0].data);
        setCurrencyYuan(parsedData[0]);
        setCurrencyRu(parsedData[1]);
        setCurrencyDolar(parsedData[2]);
        setCurrencyDRu(parsedData[3]);
        setCurrencyTYuan(parsedData[4]);
        setCurrencyTj(parsedData[5]);
        setCurrencyDT(parsedData[6]);
        setCurrencyDTj(parsedData[7]);
        setLoadData(data[0].id);
      });
  }, []);

  const handleChangeCurrencyRu = (ev) => {
    setCurrencyRu({
      key: "second",
      title: "Рубль",
      value: ev.target.value,
    });
  };

  const handleChangeCurrencyYuan = (ev) => {
    setCurrencyYuan({
      key: "first",
      title: "Юань",
      value: ev.target.value,
    });
  };

  const handleChangeCurrencyDolar = (ev) => {
    setCurrencyDolar({
      key: "third",
      title: "Доллар",
      value: ev.target.value,
    });
  };

  const handleChangeCurrencyDRu = (ev) => {
    setCurrencyDRu({
      key: "fourth",
      title: "Рубль",
      value: ev.target.value,
    });
  };

  const handleChangeCurrencyTYuan = (ev) => {
    setCurrencyTYuan({
      key: "fifth",
      title: "Юань",
      value: ev.target.value,
    });
  };

  const handleChangeCurrencyTj = (ev) => {
    setCurrencyTj({
      key: "sixth",
      title: "Сомони",
      value: ev.target.value,
    });
  };

  const onSendData = () => {
    setLoading(true);
    if (!loadData.length) {
      axios
        .put(`${CONFIG.API_URL}/currency?api_key=${apiKey}`, {
          data: JSON.stringify([
            currrencyYuan,
            currrencyRu,
            currrencyDolar,
            currrencyDRu,
            currrencyTYuan,
            currrencyTj,
            currrencyDT,
            currrencyDTj,
          ]),
          id: loadData,
        })
        .then((res) => {
          onSendDataToBot(res.data);
          setLoading(false);
          onClose();
        });
    } else {
      axios
        .post(`${CONFIG.API_URL}/currency?api_key=${apiKey}`, {
          data: [
            currrencyYuan,
            currrencyRu,
            currrencyDolar,
            currrencyDRu,
            currrencyTYuan,
            currrencyTj,
            currrencyDT,
            currrencyDTj,
          ],
        })
        .then(({ data }) => {
          onSendDataToBot(data);
          setLoading(false);
          onClose();
        });
    }
  };

  return (
    <div className="CurrenciesPage">
      <div className="CurrenciesPage-container">
        <Form layout={"vertical"}>
          <Form.Item label="Курс валют Юань*">
            <Input
              name="first"
              placeholder="Юань"
              className={"currency-form-input ym-record-keys"}
              prefix={<YuIcon />}
              value={currrencyYuan?.value || ""}
              onChange={(ev) => handleChangeCurrencyYuan(ev)}
            />
          </Form.Item>
          <div className="excnahgeCurrency">
            <ExcnahgeIcom />
          </div>
          <Form.Item label="Курс валют Рубль*">
            <Input
              name="second"
              placeholder="Рубль"
              className={"currency-form-input ym-record-keys"}
              prefix={<RuIcon />}
              value={currrencyRu?.value || ""}
              onChange={(ev) => handleChangeCurrencyRu(ev)}
            />
          </Form.Item>
          <div className="exch-hr"></div>
          <Form.Item label="Курс валют Доллар*">
            <Input
              name="third"
              placeholder="Доллар"
              className={"currency-form-input ym-record-keys"}
              prefix={<DolIcon />}
              value={currrencyDolar?.value || ""}
              onChange={(ev) => handleChangeCurrencyDolar(ev)}
            />
          </Form.Item>

          <div className="excnahgeCurrency">
            <ExcnahgeIcom />
          </div>
          <Form.Item label="Курс валют Рубль*">
            <Input
              name="fourth"
              placeholder="Рубль"
              className={"currency-form-input ym-record-keys"}
              prefix={<RuIcon />}
              value={currrencyDRu?.value || ""}
              onChange={(ev) => handleChangeCurrencyDRu(ev)}
            />
          </Form.Item>

          <div className="exch-hr"></div>
          <Form.Item label="Курс валют Юань*">
            <Input
              name="fifth"
              placeholder="Юань"
              className={"currency-form-input ym-record-keys"}
              prefix={<YuIcon />}
              value={currrencyTYuan?.value || ""}
              onChange={(ev) => handleChangeCurrencyTYuan(ev)}
            />
          </Form.Item>
          <div className="excnahgeCurrency">
            <ExcnahgeIcom />
          </div>
          <Form.Item label="Курс валют Сомони*">
            <Input
              name="sixth"
              placeholder="Сомони"
              className={"currency-form-input ym-record-keys"}
              prefix={<span className="tj-cur">TJS</span>}
              value={currrencyTj?.value || ""}
              onChange={(ev) => handleChangeCurrencyTj(ev)}
            />
          </Form.Item>
          {/* вв */}
          <div className="exch-hr"></div>
          <Form.Item label="Курс валют Доллар*">
            <Input
              name="fifth"
              placeholder="Доллар"
              className={"currency-form-input ym-record-keys"}
              prefix={<DolIcon />}
              value={currrencyDTj?.value || ""}
              onChange={(ev) =>
                setCurrencyDTj({
                  key: "seven",
                  title: "Доллар",
                  value: ev.target.value,
                })
              }
            />
          </Form.Item>
          <div className="excnahgeCurrency">
            <ExcnahgeIcom />
          </div>
          <Form.Item label="Курс валют Сомони*">
            <Input
              name="sixth"
              placeholder="Сомони"
              className={"currency-form-input ym-record-keys"}
              prefix={<span className="tj-cur">TJS</span>}
              value={currrencyDT?.value || ""}
              onChange={(ev) =>
                setCurrencyDT({
                  key: "eight",
                  title: "Сомони",
                  value: ev.target.value,
                })
              }
            />
          </Form.Item>

          <Button
            type="primary"
            loading={loading}
            onClick={() => onSendData()}
            size="large"
            block
            // disabled={!currrencies[0]?.value || !currrencies[1]?.value}
            className="currency-from-btn"
          >
            Сохранить
          </Button>
        </Form>
      </div>
    </div>
  );
};

export default CurrenciesPage;
